<template>
  <div class="table-wrapper">
    <div class="row">
      <div class="col-md-6 col-sm-12 grid-search-control">
        <SearchField
          v-model:textSearch="textSearch"
          placeholder="Search for projects by name or description"
          @input="isSpinnerVisible = true"
          @search="search"
        />
      </div>
    </div>
  
    <div 
      v-bind:class="['table-responsive', { 'spinner-is-visible': isSpinnerVisible }]"
    >
      <table class="table">
        <thead>
          <tr>
            <SortableHeader
              class="text-start"
              :current-sort="orderBy"
              :sort-by="'NAME'"
              @sort="reorder"
            >Project</SortableHeader>

            <SortableHeader
              class="text-center"
              style="width: 110px"
              :current-sort="orderBy"
              :sort-by="'DRAFT_FINDINGS'"
              @sort="reorder"
            >In Draft <strong>I</strong></SortableHeader>

            <SortableHeader
              class="text-center"
              style="width: 110px"
              :current-sort="orderBy"
              :sort-by="'REVIEW_FINDINGS'"
              @sort="reorder"
            >In Review <strong>I</strong></SortableHeader>

            <SortableHeader
              class="text-center"
              style="width: 110px"
              :current-sort="orderBy"
              :sort-by="'APPROVED_FINDINGS'"
              @sort="reorder"
            >Approved <strong>I</strong></SortableHeader>

            <SortableHeader
              class="text-center"
              style="width: 110px"
              :current-sort="orderBy"
              :sort-by="'DRAFT_REMEDIATIONS'"
              @sort="reorder"
            >In Draft <strong>R</strong></SortableHeader>

            <SortableHeader
              class="text-center"
              style="width: 110px"
              :current-sort="orderBy"
              :sort-by="'REVIEW_REMEDIATIONS'"
              @sort="reorder"
            >In Review <strong>R</strong></SortableHeader>

            <SortableHeader
              class="text-center"
              style="width: 110px"
              :current-sort="orderBy"
              :sort-by="'APPROVED_REMEDIATIONS'"
              @sort="reorder"
            >Approved <strong>R</strong></SortableHeader>

            <th
              class="text-end"
              style="width: 140px"
            >Latest Activity Date</th>

            <th data-sorter="false" class="d-none d-md-table-cell"></th>
          </tr>
        </thead>

        <tbody>
          <Project
            v-for="(item, index) in items"
            v-bind="item"
            :key="item.id"
            :index="index"
            :policy-update="policyUpdate"
            @update-status="updateProject"
            :ref="item.id"
            :selected="isItemMarked(item.id)"
          />
        </tbody>
      </table>

      <div class="spinner"></div>

      <NoRecords 
        label="There is no related projects"
      />

      <Pagination
        v-bind="pageInfo"
        entity-type="projects"
        @navigate-to="paginate"
      />
    </div>
  </div>
</template>

<script>
import Grid from "../shared/grid/grid";
import Project from "./project";

export default {
  extends: Grid,

  components: {
    Project
  },

  props: {
    clientCompanyId: String
  },

  data: function () {
    return {
      items: [],

      grid: "client-projects",

      textSearch: '',

      defaultOrderBy: {
        field: "NAME",
        direction: "DESC"
      },

      orderBy: {
        field: "NAME",
        direction: "DESC"
      },

      pageInfo: {
        pageSize: 20,
        currentPage: 1,
        totalCount: 0,
        totalPageCount: 0
      },

      isSpinnerVisible: true
    }
  },

  computed: {
    filterParams: function () {
      let params = {
        clientCompanyId: this.clientCompanyId
      };

      if (this.textSearch) {
        params.text = {
          value: this.textSearch,
          fields: this.textSearchFields
        };
      };

      return params;
    },

    textSearchFields: function () {
      return ["NAME", "DESCRIPTION"];
    }
  },

  methods: {
    fetch: function (params, success) {
      app.graphql.get("grid.projects",
        params,

        (data) => {
          let projects = data.data.projects,
              pageInfo = projects.pageInfo;

          success(projects, pageInfo);
        },

        (error) => {
          app.ui.toast.add({
            priority: "danger",
            title: "Something went wrong!",
            message: "Unable to fetch projects!"
          })
        }
      )
    },

    updateProject: function (updatedProject) {
      let project = this.items.find(function (item) {
        return item.id === updatedProject.id;
      });

      project.findingStatusCounts.approved = updatedProject.findingStatusCounts.approved;
      project.findingStatusCounts.review = updatedProject.findingStatusCounts.review;
      project.findingStatusCounts.draft = updatedProject.findingStatusCounts.draft;

      project.remediationStatusCounts.approved = updatedProject.remediationStatusCounts.approved;
      project.remediationStatusCounts.review = updatedProject.remediationStatusCounts.review;
      project.remediationStatusCounts.draft = updatedProject.remediationStatusCounts.draft;
    }
  }
}
</script>
